customElements.define('component-menu-submenu', class SubMenu extends HTMLElement {
  constructor() {
    super();
    this.template = document.createElement('template');
    this.template.innerHTML = `
      <div class="submenu-component"></div>
    `;
  }

  connectedCallback() {
    this.appendChild(this.template.content.cloneNode(true));
    // DOM elements
    this.subMenu = this.querySelector('.submenu-component');
    this.renderSubMenu();
  }

  normalizeKey(key) {
    return key.replace(/\W/g, '-').toLowerCase();
  }

  renderSubMenu() {
    const primaryColumn = document.createElement('ul');
    primaryColumn.classList.add("primary-column");

    if (this.items && this.items.length) {
      this.items.forEach((item, index) => {
        if (item.subItems && item.subItems.length) {
          const column = document.createElement('ul');
          column.classList.add("submenu-column");
          const li = this.createSubMenuItem(item, index);
          column.appendChild(li);
          const secondLevelMenu = this.createSecondSubMenu(item.subItems);
          column.appendChild(secondLevelMenu);
          this.subMenu.appendChild(column);
        } else {
          const li = this.createSubMenuItem(item, index);
          primaryColumn.appendChild(li);
        }
      });

      if (primaryColumn.childNodes.length) {
        this.subMenu.prepend(primaryColumn);
      }
    }
  }

  createSubMenuItem(item, position) {
    const li = document.createElement('li');
    // In case the URL doesn't include de domain
    if (!(/^https?:\/\//ig).test(item.url)) {
      this.baseUrlSplit = window.location.host.split('.')
      this.baseUrlSplit.shift();
      this.baseUrl = this.baseUrlSplit.join('.');
      item.url = `https://www.${this.baseUrl}${item.url}`;
    }
    li.classList.add("submenu-item");
    li.setAttribute("key", this.normalizeKey(item.title));
    li.setAttribute("data-attribute", this.normalizeKey(item.title));
    li.setAttribute("id", this.normalizeKey(item.title));
    const a = document.createElement('a');
    a.classList.add("submenu-link");
    a.setAttribute("href", item.url || '#');
    a.innerHTML = item.title;
    a.addEventListener('click', () => {
      this.trackGTM('menu-sub-menu-click', 'menu-sub-menu', item.title, item.url, position);
    });
    li.appendChild(a);

    return li;
  }

  createSecondSubMenu(items) {
    const ul = document.createElement('ul');
    ul.classList.add("second-submenu");
    items.forEach((item, index) => {
      // In case the URL doesn't include de domain
      if (!(/^https?:\/\//ig).test(item.url)) {
        this.baseUrlSplit = window.location.host.split('.')
        this.baseUrlSplit.shift();
        this.baseUrl = this.baseUrlSplit.join('.');
        item.url = `https://www.${this.baseUrl}${item.url}`;
      }
      const li = document.createElement('li');
      li.classList.add("second-submenu-item");
      li.setAttribute("key", this.normalizeKey(item.title));
      li.setAttribute("data-attribute", this.normalizeKey(item.title));
      li.setAttribute("id", this.normalizeKey(item.title));
      const a = document.createElement('a');
      a.classList.add("second-submenu-link");
      a.setAttribute("href", item.url || '#');
      a.innerHTML = item.title;
      a.addEventListener('click', () => {
        this.trackGTM('menu-second-sub-menu-click', 'menu-second-sub-menu', item.title, item.url, index);
      });

      li.appendChild(a);
      ul.appendChild(li);
    });

    return ul;
  }

  trackGTM(event, source, title, url, position) {
    window.sendGTMData && window.sendGTMData({
      event,
      source,
      nav_bar_section_text: title,
      nav_bar_section_position: position,
      nav_bar_section_url: url
    });
  }
});



